import { render, staticRenderFns } from "./contract-ledger.vue?vue&type=template&id=3bed2606&"
import script from "./contract-ledger.vue?vue&type=script&lang=js&"
export * from "./contract-ledger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports